import React, { FunctionComponent } from 'react';
import styles from './ProgressBar.scss';

export interface ProgressBarProps {
  percent: number;
}
export const ProgressBar: FunctionComponent<ProgressBarProps> = props => {
  return (
    <div className={styles.progressBarContainer}>
      <div
        className={styles.foregroundBar}
        style={{ width: props.percent + '%' }}
      ></div>
    </div>
  );
};
